import { useSelector } from 'react-redux';
import { getIsAlgosConfig } from '../../../../../reducers';
import { getAlgoEditConfig } from '../../../../../stores/algo-edit-config/getters';

export default function useInstrument() {
  const underlyingsExpiryTags = useSelector((state) => {
    const { underlyingsExpiryTags = {} } = getIsAlgosConfig(state);

    return underlyingsExpiryTags;
  });

  const day = useSelector((state) => {
    const { day = 'ELSE' } = getAlgoEditConfig(state);

    return day;
  });

  const targetContract = underlyingsExpiryTags[day];

  return targetContract;
}
